<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title mb-0 px-2 pt-2">
        <div [ngClass.xl]="'float-left'" [ngClass.sm]="'mb-075'" [ngClass.md]="'float-left'">
          <label class="d-flex align-items-center">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" />
          </label>
        </div>
        <div class="float-right">
          <div [ngClass.xl]="'w-fit d-inline-block mr-2'" [ngClass.sm]="'d-none'" [ngClass.md]="'w-fit d-inline-block mr-2'">
            <label class="d-flex align-items-center"
              >{{ "SHOW" | translate }}
              <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
          <a (click)="modalOpen(categoryAdd, null)" class="btn btn-outline-primary text-primary" *ngIf="_authenticationService.hasCapability('workday_category_create')">{{ "ADD" | translate }}</a>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body px-0 pb-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 50 : 75"
          [limit]="tableLimit"
          [footerHeight]="60"
          [rows]="categoryList()"
        >
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" [sortable]="true" width="700" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" width="100" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button (click)="modalOpen(categoryEdit, row)" class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('workday_category_edit')">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deleteCategory(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('workday_category_delete')">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" [width]="null" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12" [ngClass.md]="'pl-0'">
                  <div class="d-flex justify-content-between align-items-center" ngClass.md="pr-1">
                    <span>{{ row.name }}</span>
                    <div>
                      <button (click)="modalOpen(categoryEdit, row)" class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('workday_category_edit')">
                        <i [data-feather]="'edit-2'" size="19"></i>
                      </button>
                      <button (click)="deleteCategory(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('workday_category_delete')">
                        <i [data-feather]="'trash-2'" size="19"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
<!-- Modal Add -->
<ng-template #categoryAdd let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "ADD" | translate }} {{ "CATEGORY" | translate }}</h3>
    <label [for]="'new_category'">{{ "CATEGORY" | translate }}<sup class="text-danger">*</sup></label>
    <input [(ngModel)]="new_category" name="new_category" type="text" [id]="'new_category'" class="form-control" />
    <div class="font-error" *ngIf="showModalError && (!new_category || new_category.length < 1)">{{ "ERRORS.FIELD_CATEGORY" | translate }}</div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button (click)="addCategory()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Add -->

<!-- Modal Edit -->
<ng-template #categoryEdit let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "EDIT" | translate }} {{ "CATEGORY" | translate }}</h3>
    <label [for]="'category'">{{ "CATEGORY" | translate }}<sup class="text-danger">*</sup></label>
    <input name="currentCategoryName" [(ngModel)]="currentCategory.name" type="text" [id]="'category'" class="form-control" />
    <div class="font-error" *ngIf="showModalError && (!currentCategory.name || currentCategory.name.length < 1)">{{ "ERRORS.FIELD_CATEGORY" | translate }}</div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button (click)="editCategory()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "EDIT" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Edit -->
